'use client';

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import { MCP_CLIENTS, MCP_PREVIEW_SNIPPETS, McpClient } from '../lib/clients';
import ClientTabs from './ClientTabs';
import styles from './mcp-clients.module.scss';
import layout from '../../product-landing/product-landing.module.scss';

export default function McpPreview() {
  const { t } = useTranslation('start');
  const [client, setClient] = useState<McpClient>('chatgpt');
  return (
    <div>
      <div className={`${layout.preview} ${styles.preview}`}>
        <div className={`${layout.previewHeader} ${styles.previewHeader}`}>
          <span>{t('mcp.hero.eyebrow')}</span>
          <AccountTreeOutlinedIcon aria-hidden="true" />
        </div>
        <ClientTabs
          id="mcp-preview"
          label={t('mcp.hero.previewLabel')}
          clients={MCP_CLIENTS}
          value={client}
          onChange={setClient}
        />
        <div className={styles.previewPanels}>
          {MCP_CLIENTS.map((key) => (
            <div
              key={key}
              role="tabpanel"
              id={`mcp-preview-panel-${key}`}
              aria-labelledby={`mcp-preview-tab-${key}`}
              hidden={key !== client}
              className={styles.previewPanel}
              tabIndex={0}
            >
              <h3>{t(`mcp.preview.${key}.title`)}</h3>
              <p>{t(`mcp.preview.${key}.body`)}</p>
              <pre className={layout.code}>
                <code>{MCP_PREVIEW_SNIPPETS[key]}</code>
              </pre>
              <p>{t(`mcp.preview.${key}.after`)}</p>
            </div>
          ))}
        </div>
      </div>
      <p className={styles.attribution}>{t('mcp.brandAttribution')}</p>
    </div>
  );
}
